import { IFormController } from 'angular';
import { AuthContextUser } from 'contexts';
import { useMixpanel } from 'hooks';
import { MixpanelEvent } from 'hooks/useMixpanel/events';
import React from 'react';
import { HashRouter, Route } from 'react-router-dom';

export type SaveButtonWithMixpanelProps = {
  form: IFormController;
  submit: (form: IFormController, trackEvent: () => void) => void;
  disabled: boolean;
  auth: AuthContextUser;
  additionalClass?: string;
};

const SaveButtonWithMixpanel: React.FC<SaveButtonWithMixpanelProps> = ({
  form,
  submit,
  disabled,
  auth,
  additionalClass,
}) => {
  const { trackEvent } = useMixpanel({ auth });

  return (
    <button
      onClick={() =>
        submit(form, () => trackEvent(MixpanelEvent.ShowingConfigurationSaved))
      }
      disabled={disabled}
      className={`btn btn-primary ${additionalClass || ''}`}
      data-cy="save-config-change"
    >
      Save
    </button>
  );
};

export default (props: any) => (
  <HashRouter>
    <Route render={() => <SaveButtonWithMixpanel {...props} />} />
  </HashRouter>
);
